import React from "react";
import styled from "styled-components";


export default styled.div`
    width: 162px;
    height: 48px;
    padding: 18px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 125ms;

    i {
        margin-right: 10px;
    }

    &:hover {
        background-color: rgb(231 241 249);
        color: rgb(78 153 214);
    }
`;
